// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-ActivityStartPage{
    font-family: sans-serif;
    font-size: 4vh;
    padding: 3%;
    color: white;
    text-align: center;
}

.StartActivityContainer{
    width: auto;
    height: auto;
    padding: 5% 7% 5% 7%;
    background-color: rgb(255, 255, 255);
    box-shadow: 10px 10px 10px 10px rgb(185, 184, 184);
    border-radius: 2vh;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: center;
    text-align: center;
    width: 50%;
    margin-left: 30%;
}


.ActivityStartDetails{
    display: flex;
    align-items: center;
    justify-content: flex-start;

}`, "",{"version":3,"sources":["webpack://./src/MyComponents/Activities/ActivityStart/ActivityStartPage.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;;AAE/B","sourcesContent":[".student-ActivityStartPage{\n    font-family: sans-serif;\n    font-size: 4vh;\n    padding: 3%;\n    color: white;\n    text-align: center;\n}\n\n.StartActivityContainer{\n    width: auto;\n    height: auto;\n    padding: 5% 7% 5% 7%;\n    background-color: rgb(255, 255, 255);\n    box-shadow: 10px 10px 10px 10px rgb(185, 184, 184);\n    border-radius: 2vh;\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n    justify-content: center;\n    text-align: center;\n    width: 50%;\n    margin-left: 30%;\n}\n\n\n.ActivityStartDetails{\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
